import { render, staticRenderFns } from "./user.vue?vue&type=template&id=219c0fd7&scoped=true&"
import script from "./user.vue?vue&type=script&lang=ts&"
export * from "./user.vue?vue&type=script&lang=ts&"
import style0 from "./user.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./user.vue?vue&type=style&index=1&id=219c0fd7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219c0fd7",
  null
  
)

export default component.exports